/**
 * Theme context + hook. Lives separately from ThemeProvider.tsx so that
 * file exports only the React component — keeps Fast Refresh happy
 * (react-refresh/only-export-components).
 */
import { createContext, useContext } from "react";

export type Mode = "light" | "dark";

export type ThemeValue = {
  mode: Mode;
  toggle: () => void;
  set: (mode: Mode) => void;
};

export const ThemeContext = createContext<ThemeValue | null>(null);

export function useTheme(): ThemeValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
}
